import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collections: {},
  requesting: true,

  isDeleted: false,
  deleting: false,

  errors: {}
};

const Slice = createSlice({
  name: '@admin/Companies|List',
  initialState,
  reducers: {
    
    getList: (state) => {
        state.collections = {};
        state.requesting = true;
    },
    getListSuccess: (state, action) => {
        const { payload } = action;
        state.collections = payload;
        state.requesting = false;
    },
    getListFailed: (state, action) => {
        state.errors = action.payload;
        state.requesting = false;
    },

  // ----- DELETE ----- 
    toDelete: (state) => {
        state.isDeleted = false;
        state.deleting = true;
    },
    toDeleteSuccess: (state) => {
        state.isDeleted = true;
        state.deleting = false;
    },
    toDeleteFailed: (state, action) => {
        state.errors = action.payload;
        state.deleting  = false;
        state.isDeleted = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminCompaniesListReducers: Slice.reducer,
}
export default Reducers;

